module.exports = __webpack_public_path__ + "static/media/blog-1.f8a971d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog-1.jpg
// module id = 842
// module chunks = 0